import React from 'react'
import { useAuth } from '../AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import UserStatus from './UserStatus';
import PublicRoute from '../PublicRoute';
import AlertTypes from './AlertTypes';
import LiveAlertScroller from './LiveAlertScroller';
import LatestAlertScroller from './LatestAlertScroller';


function Home() {
  const { user } = useAuth();

  return (
    <PublicRoute>
      <div className="page-container">
        <div className="content-wrap">
          {/* ================= NAVBAR (UNCHANGED) ================= */}
          <section className="navbar-area navbar-one">
            <div className="container">
              <nav className="navbar navbar-expand-lg">
                <a className="navbar-brand" href="/">
                  <img width="200" height="70" src={require("../images/logo.png")} alt="Logo" />
                </a>

                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarOne">
                  <span className="toggler-icon"></span>
                  <span className="toggler-icon"></span>
                  <span className="toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse sub-menu-bar" id="navbarOne">
                  <ul className="navbar-nav m-auto">
                    <li className="nav-item"><a className="active page-scroll" href="/">Home</a></li>
                    <li className="nav-item"><a className="page-scroll" href="/pricing">Pricing</a></li>
                    <li className="nav-item"><a className="page-scroll" href="/referral">Refer and Win</a></li>
                    <li className="nav-item"><a className="page-scroll" href="/faq">FAQ</a></li>
                    <li className="nav-item"><a className="page-scroll" href="/contact">Contact Us</a></li>
                  </ul>
                </div>

                <div className="navbar-btn">
                  <UserStatus />
                </div>
              </nav>
            </div>
          </section>

  <section id="hero-area" className="header-area header-ten">
    <div className="header-inner">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 co-12">
            <div className="home-slider">
              <div className="header-text">
                <h1 style = {{color: '#002F6C', fontWeight: '600', fontFamily: 'Poppins, sans-serif', fontSize:'42px', marginTop:'30px'}}>
                  Maximize Profit with DSE Alerts 
                </h1>
              <p className="hero-subtitle">
                Get instant stock alerts on <strong>Telegram & SMS</strong> for
                price levels, breakouts, volume spikes, indicators and news.
              </p>
        <div className="light-rounded-buttons">
                  <a style = {{margin: '5px'}}href="/signup" className="btn primary-btn"> Get Started Free </a>
                  <a style = {{margin: '5px'}} href="#alert-examples" className="btn primary-btn"> See Alert Examples </a>
              </div>
            </div>
          </div>
        </div>
          <div className="col-lg-6 col-12">
            <div className="header-image">
                  <a href="/signup" className="overlay-link"></a>
              <img className="shape3" src={require("../images/shape3.png")} alt="#" />
             </div>
            </div>
          </div>
      </div>
    </div>
  </section>

      {/* ================= LIVE ALERT SCROLLER ================= */}
      <section className="alert-section">
        <div className="container">
          <div className="row">

        <div className="col-md-6 mb-4 d-flex">
          <div className="alert-box w-100">
            <LiveAlertScroller />
          </div>
        </div>

        <div className="col-md-6 mb-4 d-flex">
          <div className="alert-box w-100">
            <LatestAlertScroller />
          </div>
        </div>

          </div>
        </div>
      </section>

      {/* ================= ALERT TYPES ================= */}
      <section id="alert-examples" className="about-section">
        <div className="container">

          <div className="row text-center mb-5">
            <h2 className="section-title">Alerts You Can Receive</h2>
          </div>

          <div className="row">

            {[
              ["Price Level Alerts", "Get notified when price reaches your set levels."],
              ["Breakout & Breakdown", "Price is moving strongly up or down."],
              ["Volume Spike", "Large volume compared to recent trends."],
              ["Overbought / Oversold", "Price may be getting too high or too low."],
              ["Golden / Death Cross", "Potential change to bull or bear trend."],
              ["Significant Price Change", "Get alert when your stock prices rises / falls by 5% or 10%"],
              ["Peak / Bottom Price Level", "Price reaches 1 year high or low"],
              ["Latest Market News", "News impacting stock price delivered instantly."]
            ].map(([title, text], index) => (
              <div className="col-md-6 mb-4" key={index}>
                <div className="info-card">
                  <h4>{title}</h4>
                  <p>{text}</p>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>

      {/* ================= DELIVERY ================= */}
      <section className="delivery-section">
        <div className="container">

          <div className="row text-center mb-5">
            <h2 className="section-title">
              Receive Alerts Where You Already Are
            </h2>
          </div>

          <div className="row">

            <div className="col-md-6 mb-4">
              <div className="info-card">
                <h4>Telegram</h4>
                <p>Fast, free, easy to mute. Best for frequent alerts.</p>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="info-card">
                <h4>SMS</h4>
                <p>Works without internet. Best for critical alerts.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ================= HOW IT WORKS ================= */}
      <section className="how-section">
        <div className="container">

          <div className="row text-center mb-5">
            <h2 className="section-title">How It Works</h2>
          </div>

          <div className="row text-center">

            <div className="col-md-4 mb-4">
              <h5>1. Signup</h5>
              <p>Choose Free Trial or Paid Plans</p>
            </div>

            <div className="col-md-4 mb-4">
              <h5>2. Select Stocks</h5>
              <p>Choose DSE stocks you want to track</p>
            </div>

            <div className="col-md-4 mb-4">
              <h5>3. Configure Alerts</h5>
              <p>Set price, indicators or news alerts</p>
            </div>

          </div>

          <div className="text-center mt-4">
            <a href="/signup" className="btn btn-primary">
              Try Free
            </a>
          </div>

        </div>
      </section>
    </div>

        {/* ================= FOOTER (UNCHANGED) ================= */}
        <section className="footer-area footer-five">
          <div className="container">
            <div className="footer-top-content">
              <div className="footer-links">
                <ul>
                  <li><a href="/terms" target="_blank" rel="noopener noreferrer">Terms & Conditions</a></li>
                  <li><a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
                </ul>
              </div>

              <div className="footer-contact">
                <h4>Contact Us:</h4>
                <a href="mailto:support@tradebarta.com">support@tradebarta.com</a>
              </div>
            </div>
          </div>

          <div className="footer-copyright">
            <div className="container">
              <p className="text-center">Copyright © 2025. All Rights Reserved</p>
            </div>
          </div>
        </section>

      </div>
    </PublicRoute>
  )
}

export default Home;
